import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Users, ChevronRight, Info } from "lucide-react";
import { CoinIcon } from "@/components/app/AuramaxChip";
import { WalletPanel } from "@/components/app/WalletConnect";
import { GenesisBalanceCard } from "@/components/genesis/GenesisBalanceCard";

export default function Balance() {
  const navigate = useNavigate();
  return (
    <div className="mx-auto max-w-xl px-4 py-5 md:px-6" data-testid="balance-page">
      <button onClick={() => navigate(-1)} className="mb-4 flex items-center gap-1 text-sm text-am-text2 hover:text-white"><ArrowLeft className="h-4 w-4" /> Back</button>
      <div className="relative overflow-hidden rounded-3xl border border-[#d4a84b]/30 bg-am-surface p-8 text-center">
        <div className="pointer-events-none absolute -top-16 left-1/2 h-48 w-48 -translate-x-1/2 rounded-full bg-[#d4a84b] opacity-[0.12] blur-3xl" />
        <span className="relative mx-auto grid h-16 w-16 place-items-center rounded-full border border-[#d4a84b]/40 bg-[#d4a84b]/10 text-[#e5c067]"><CoinIcon size={34} /></span>
        <div className="relative mt-5"><WalletPanel /></div>
      </div>

      <GenesisBalanceCard />

      <button onClick={() => navigate("/referrals")} data-testid="balance-invite" className="mt-4 flex w-full items-center gap-3 rounded-2xl border border-am-border bg-am-surface2 p-4 text-left hover:bg-white/5">
        <span className="grid h-11 w-11 place-items-center rounded-xl aura-gradient"><Users className="h-5 w-5 text-black" /></span>
        <div className="flex-1"><div className="text-sm font-bold text-white">Invite friends to AuraMax</div><div className="text-xs text-am-text2">Share your link and grow the network with you.</div></div>
        <ChevronRight className="h-5 w-5 text-am-text3" />
      </button>

      <button onClick={() => navigate("/token")} data-testid="balance-about" className="mt-2 flex w-full items-center gap-3 rounded-2xl border border-am-border bg-am-surface2 p-4 text-left hover:bg-white/5">
        <span className="grid h-11 w-11 place-items-center rounded-xl border border-am-border bg-am-surface text-[#e5c067]"><Info className="h-5 w-5" /></span>
        <div className="flex-1"><div className="text-sm font-bold text-white">About $AURAMAX</div><div className="text-xs text-am-text2">What it is and what's planned.</div></div>
        <ChevronRight className="h-5 w-5 text-am-text3" />
      </button>

      <p className="mt-6 text-center text-xs text-am-text3" data-testid="balance-footnote">Balances are read directly from Solana mainnet. Read-only — AuraMax never holds your keys.</p>
    </div>
  );
}
